import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/home/index.vue'
import RetrieveIndex from '@/views/retrieve/index.vue'
import BookDetail from '@/views/retrieve/BookDetail.vue'
import UserIndex from '@/views/user/index.vue'
import HelpIndex from '@/views/help/index.vue'
import UserInfo from '@/views/user/UserInfo.vue'
import MyAccount from '@/views/user/MyAccount.vue'
import MyNote from '@/views/user/MyNote.vue'
import ViewHistory from '@/views/user/ViewHistory.vue'
import MyCollection from '@/views/user/MyCollection.vue'
import RetrieveHome from '@/views/retrieve/RetrieveHome.vue'
import RetrieveResult from '@/views/retrieve/RetrieveResult.vue'
import AdvancedSearch from '@/views/retrieve/AdvancedSearch.vue'
import RetrieveIntroduction from '@/views/retrieve/RetrieveIntroduction.vue'
import AdvancedSearchResult from '@/views/retrieve/AdvancedSearchResult.vue'
import ChangePassword from '@/views/home/ChangePasswordPage.vue'
import ChangePasswordWithUsername from '@/views/home/ChangePasswordWithUsernamePage.vue'
import ArticleView from '@/views/article/ArticleView.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      redirect: '/home'
    },
    {
      path: '/home',
      component: HomeIndex
    },
    {
      path: '/:url?/changePassword',
      component: ChangePassword
    },
    {
      path: '/:url?/changePasswordWithUsername',
      component: ChangePasswordWithUsername
    },
    {
      path: '/:url?/retrieve',
      component: RetrieveIndex,
      children: [
        {
          path: 'retrieveHome',
          component: RetrieveHome,
          meta: {
            keepAlive: true,
            routerViewKey: 'retrieve-home-page'
          },
          children: [
            {
              path: 'introduction',
              component: RetrieveIntroduction,
              meta: {
                keepAlive: true,
                routerViewKey: 'retrieve-home-page'
              }
            },
            {
              path: 'retrieveResult',
              component: RetrieveResult,
              meta: {
                keepAlive: true,
                routerViewKey: 'retrieve-home-page'
              }
            }
          ]
        },
        {
          path: 'advancedSearch',
          component: AdvancedSearch
        },
        {
          path: 'advancedSearchResult',
          component: AdvancedSearchResult
        }
      ],
      redirect: '/retrieve/retrieveHome/introduction'
    },
    {
      path: '/:url?/bookDetail',
      component: BookDetail
    },
    {
      path: '/:url?/user',
      component: UserIndex,
      children: [
        {
          path: 'userInfo',
          component: UserInfo
        },
        {
          path: 'myAccount',
          component: MyAccount
        },
        {
          path: 'myNote',
          component: MyNote
        },
        {
          path: 'viewHistory',
          component: ViewHistory
        },
        {
          path: 'myCollection/:folderId',
          component: MyCollection
        }
      ],
      redirect: '/user/userInfo'
    },
    {
      path: '/:url?/help',
      component: HelpIndex
    },
    {
      path: '/:url?/article/:filename',
      component: ArticleView
    },
    {
      path: '*',
      redirect: '/home'
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js